export const FOLDERS = {
  GENERAL_SETTINGS: 'generalSettings',
  TIME_TRACKING: 'timeTracking',
  ABSENCE_MANAGER: 'absenceManager',
  SHIFT_PLANNER: 'shiftPlanner',
  WORKFORCE_MANAGEMENT: 'workforceManagement',
  BUY_LICENSE: 'buyLicense',
};

export const FOLDER_CAN_BE_VIEWED = {
  [FOLDERS.ABSENCE_MANAGER]: 'canUseAbsenceManagement',
  [FOLDERS.TIME_TRACKING]: 'canUseTimeTracking',
  [FOLDERS.SHIFT_PLANNER]: 'canUseShiftPlanner',
};

export const INPUT_TYPES = {
  GPS_LOCATION: { name: 'geofence', initialValue: {} },
  HEADER_LABEL: { name: 'header-label', initialValue: '' },
  INPUT_BOOLEAN: { name: 'input-boolean', initialValue: false },
  INPUT_DATE: { name: 'input-date', initialValue: new Date('01/01/1970') },
  INPUT_DAYS: { name: 'input-days', initialValue: 0 },
  INPUT_HOURS: { name: 'input-hours', initialValue: 0 },
  INPUT_LOCAL_TIME: { name: 'input-local-time', initialValue: null },
  INPUT_PASSWORD: { name: 'input-password', initialValue: '' },
  INPUT_STRING: { name: 'input-string', initialValue: '' },
  MEMBER_OVERWRITE: { name: 'member-overwrite', initialValue: {} },
  PROFILE_PICTURE: { name: 'profile-picture', initialValue: '' },
  SELECTION_LIST: { name: 'selection-list', initialValue: [] },
  SINGLE_SELECTION: { name: 'single-selection', initialValue: '' },
  TAGGED_LIST: { name: 'tagged-list', initialValue: [] },
  VERSION_INPUT: { name: 'version-input', initialValue: {} },
};

export const PRIMARY_SETTING_PRIORITY = {
  HIGH_PRIORITY: 1,
  MEDIUM_PRIORITY: 2,
  LOW_PRIORITY: 3,
};

export const SETTING_ELEMENT_TYPE = {
  SETTING_GROUP: 'settingGroupDefinition',
  SETTING_OBJECT_TYPE: 'settingObjectTypeDefinition',
};

export const SETTINGS_IDS = {
  TIME_ACCOUNT: 'com.crewmeister.platform.time.account',
  SHIFT_TO_WORKING_TIME: 'com.crewmeister.platform.shift.to.working.time',
  WORKING_TIME_FRAME: 'com.crewmeister.wfm.working_time_frame',
};

export const SETTINGS_COMING_FROM_THE_BACKEND = [SETTINGS_IDS.SHIFT_TO_WORKING_TIME, SETTINGS_IDS.TIME_ACCOUNT];

// Synthesized, frontend-only `displayCondition`s for backend-driven settings whose backend
// definition doesn't carry one (platform-app only enforces its own write-gate here, not this).
// `settingInput` is the FULLY QUALIFIED field id, not the short suffix translator-based settings
// use — because backend-driven `id`s in getInputs stay double-prefixed (kept for E2E automation
// that already targets the existing DOM id), and RightPanelComponents' unmodified matching
// (`${settingGroupId}.${settingInput}`) needs a fully-qualified settingInput to land on that same
// double-prefixed value. getValuesFromDictionary, a different consumer, uses this value as-is
// (no re-prefixing) against settingsDict, which is unaffected by any of this.
export const BACKEND_DRIVEN_DISPLAY_CONDITIONS: Record<string, { settingInput: string; value: unknown }> = {
  [`${SETTINGS_IDS.TIME_ACCOUNT}.minimum.input`]: { settingInput: `${SETTINGS_IDS.TIME_ACCOUNT}.input`, value: true },
  [`${SETTINGS_IDS.TIME_ACCOUNT}.maximum.input`]: { settingInput: `${SETTINGS_IDS.TIME_ACCOUNT}.input`, value: true },
};

export const SETTINGS_WHICH_CAN_SET_VALID_FROM_AND_TO = [SETTINGS_IDS.SHIFT_TO_WORKING_TIME, SETTINGS_IDS.TIME_ACCOUNT, SETTINGS_IDS.WORKING_TIME_FRAME];

export const SETTINGS_WHICH_SHOULD_ALWAYS_ASK_FOR_VALID_FROM_AND_TO = [
  SETTINGS_IDS.SHIFT_TO_WORKING_TIME,
  SETTINGS_IDS.TIME_ACCOUNT,
  SETTINGS_IDS.WORKING_TIME_FRAME,
];
